export default "__VITE_ASSET__B5T2kKyV__"